import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const CONSENT_KEY = "clarity_consent";

export const getClarityConsent = () => localStorage.getItem(CONSENT_KEY);

const ClarityConsentBanner = ({ open, onClose }) => {
  const { t } = useTranslation();

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    if (window.clarity) {
      window.clarity("consentv2", { analytics_Storage: "granted", ad_Storage: "denied" });
    }
    onClose();
  };

  const handleDeny = () => {
    localStorage.setItem(CONSENT_KEY, "denied");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleDeny}>
      <DialogTitle>{t("clarityConsent.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("clarityConsent.description")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDeny} color="primary">
          {t("clarityConsent.deny")}
        </Button>
        <Button onClick={handleAccept} color="primary" autoFocus>
          {t("clarityConsent.accept")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClarityConsentBanner;
